
import _ from "lodash";
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import Path from "@/lib/common/path";
import PostPolicy from "@/lib/model/gateway/post-policy";
import gateway from "@/lib/request/gateway";
import E, { KEditor } from "./ckeditor";

declare const CKEDITOR: E;
/*
 * 注意使用 v-model绑定时
 *  如果对绑定值需要在父组件变更请勿使用v-model 会出现多次出发赋值操作 !!尤其在绑定值为计算属性时!!
 * 通过绑定value 及change事件实现双向绑定
 */
@Component
export default class Editor extends Vue {
  @Model("change", { type: String }) private readonly value!: string;
  @Prop({ type: String, default: "" }) private readonly placeholder!: string;
  @Prop({ type: String, default: "CKEnone" })
  private readonly keyIndex!: string;
  @Prop({ type: String, default: "none" }) private readonly tabIndex!: string;
  @Prop({ type: Boolean, default: false }) disable!: boolean; //只读模式
  @Prop({ default: false }) singleUse!: boolean; //单独使用
  @Prop({ type: Boolean, default: true }) showUploadImage!: boolean;
  @Prop({ type: String, default: "" }) height?: string;
  @Prop({ type: Boolean, default: false }) noneBlocks!: boolean;
  @Prop({ type: Boolean, default: false }) disCopyUploadImg?: boolean;
  name = "editor";
  editor!: null | KEditor;
  policyMap: _.Dictionary<PostPolicy> = {};
  seq: number[] = [];
  seqIdx = 0;
  isOnFocus = false;
  //此value仅仅是函数传入  用户输入字符仅在ckeditor自身监听绑定生效
  @Watch("value")
  onValueChange(to: string) {
    if (to !== String(this.editor?.getData())) {
      this?.setData(to);
    }
  }
  @Emit("change")
  change(value: string) {
    return value;
  }
  //清空 or 赋值
  open(clear = false) {
    const t = clear === false ? this.value : "";
    this?.setData(t);
  }
  private setData(value: string) {
    if (this.editor) {
      const idx = this.seqIdx++;
      this.seq.push(idx);
      if (idx !== this.seq[0]) {
        const interval = setInterval(() => {
          if (idx === this.seq[0]) {
            this.editor?.setData(value, {
              callback: () => {
                this.seq.shift();
              }
            });
            clearInterval(interval);
          }
        }, 50);
      } else {
        this.editor?.setData(value, {
          callback: () => {
            this.seq.shift();
          }
        });
      }
    }
  }

  fkCKE() {
    //
  }

  setValue(value: string) {
    this.change(value);
  }

  getValue(): string {
    return this.editor ? this.editor.getData() : "";
  }

  insertText(text: string) {
    this.editor?.insertText(text);
  }

  insertHtml(html: string) {
    this.editor?.insertHtml(html);
  }

  mounted() {
    this.init();
  }

  // 检查是否只读，如果disable为true应设为只读
  @Watch("disable")
  checkOnlyRead() {
    setTimeout(() => {
      const xpath = '//div[@id="' + "cke_" + this.keyIndex + '"]//iframe';
      const iframe: any = document.evaluate(xpath, document).iterateNext();
      const body = iframe.contentWindow.document.body;
      body.setAttribute("contentEditable", this.disable ? "false" : "true");
    }, 1000);
  }
  init() {
    const toolbarGroups = [
      {
        name: "basicstyles",
        groups: ["basicstyles", "cleanup"]
      }
    ];
    if (this.showUploadImage) {
      toolbarGroups.push({ name: "insert", groups: ["insert"] });
    }
    toolbarGroups.push(
      ...[
        // {
        //   name: "other",
        //   items: [
        //     "JustifyLeft",
        //     "JustifyCenter",
        //     "JustifyRight",
        //     "JustifyBlock",
        //   ],
        // },
        //{ name: "links", groups: ["links", "list"] },
        {
          name: "paragraph",
          groups: this.noneBlocks ? ["indent"] : ["indent", "blocks"]
        },
        {
          name: "paragraph",
          groups: this.noneBlocks
            ? ["list", "indent", "align", "bidi"]
            : ["list", "indent", "blocks", "align", "bidi"]
        }
      ]
    );
    this.editor = CKEDITOR.replace(this.$refs.editor as HTMLElement, {
      allowedContent: true,
      extraPlugins: "image2,uploadimage,justify,showblocks",
      removePlugins: "image",
      toolbarGroups: toolbarGroups,
      removeButtons:
        "Underline,Strike,Subscript,Superscript,RemoveFormat,HorizontalRule,SpecialChar,Outdent,Indent,About,Print,NewPage,Save,Templates,Scayt,SelectAll,Find,Replace,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,Language,Anchor,Flash,Smiley,Iframe,ShowBlocks,CopyFormatting,FontSize,Font,Cut,Copy,Maximize,ExportPdf,BidiRtl,BidiLtr,PageBreak",
      exportPdf_tokenUrl: "/",
      removeDialogTabs: "image:advanced;link:advanced",
      uploadUrl: "https://oss.hina.com",
      filebrowserImageUploadUrl: "https://oss.hina.com",
      editorplaceholder: this.placeholder
    });
    //解决ck5的反人类换行
    this.editor.config.enterMode = CKEDITOR.ENTER_BR;
    this.editor.config.shiftEnterMode = CKEDITOR.ENTER_P;
    if (this.height) {
      this.editor.config.height = this.height;
    }
    this.checkOnlyRead();
    if (this.disCopyUploadImg) {
      this.editor.on("paste", (evt: any) => {
        console.log(evt, "evtevtevtevt", evt.data.dataValue);
        // nextTick(() => {
        // evt.cancel();
        const data = evt.data;
        // 检查粘贴的数据中是否包含图片
        // console.log(evt.data.dataValue)
        // console.log(data.dataValue.repalce(/<img[^>]*>/, ''), data.dataValue);
        if (!data.dataValue) {
          // 如果找到图片标签，阻止默认粘贴行为
          evt.cancel();
        }
      });
    }
    this.setData(this.value);
    this.editor.on("change", evt => {
      if (this.singleUse) {
        //当做文本域 独立使用
        this.change(evt.editor.getData());
        return;
      }
      if ("CKE" + this.tabIndex !== this.keyIndex) return; //只处理当前的编辑器
      //用户输入值回传 相当于手动双向绑定model
      // if (this.value !== String(this.editor?.getData())) {
      this.change(evt.editor.getData());
      // }
    });
    this.editor.on("fileUploadRequest", evt => {
      if (this.disCopyUploadImg) {
        evt.stop();
        evt.cancel();
        return;
      }
      const fileLoader = evt.data.fileLoader,
        formData = new FormData(),
        xhr = fileLoader.xhr;
      gateway
        .anonymousGetPostPolicy(evt.data.fileLoader.fileName)
        .then(policy => {
          this.policyMap[fileLoader.id] = policy;
          formData.set("OSSAccessKeyId", policy.accessid);
          formData.set("policy", policy.policy);
          formData.set("Signature", policy.signature);
          formData.set("key", policy.dir);
          formData.set("file", evt.data.fileLoader.file);
          formData.set("success_action_status", "201");
          xhr.open("POST", policy.cdn, true);
          xhr.send(formData);
        })
        .catch(() => {
          evt.cancel();
        });

      // Prevented the default behavior.
      evt.stop();
    });
    this.editor.on("fileUploadResponse", evt => {
      // Prevent the default response handler.
      if (this.disCopyUploadImg) {
        evt.stop();
        evt.cancel();
        return;
      }
      evt.stop();
      // Get XHR and response
      const data = evt.data;
      const xhr = evt.data.fileLoader.xhr;
      if (xhr.status !== 201) {
        evt.cancel();
      } else {
        const policy = this.policyMap[data.fileLoader.id];
        data.url = Path.join(policy.cdn, encodeURIComponent(policy.dir));
        this.$nextTick(() => {
          // 复制图片，显示上传成功后无值现象
          this.change(evt.editor.getData());
        });
      }
    });
    // 监听focus 事件
    this.editor.on("focus", () => {
      this.isOnFocus = true;
      this.$emit("focus");
    });
    this.editor.on("blur", () => {
      this.editor?.fire("change");
      setTimeout(() => {
        this.isOnFocus = false;
      }, 100);
    });
  }
  beforeDestroy() {
    this.editor?.destroy();
    this.editor = null;
  }
  destroyed() {
    this.editor?.destroy();
    this.editor = null;
  }
  destroyedMy() {
    if (!this.editor) return;
    this.editor?.destroy();
    this.editor = null;
  }
  insertData() {
    // if (!flag && !this.ischange) {
    //   const range = new CKEDITOR.dom.range(this.editor?.document);
    //   range.collapse(false);
    //   range.selectNodeContents(this.editor?.document.getBody());
    //   range.collapse(false);
    //   this.editor?.getSelection().selectRanges([range]);
    //   this.ischange = false;
    // }

    if (this.isOnFocus) {
      setTimeout(() => {
        this.editor?.insertHtml("()");
        this.editor?.setReadOnly(true);
        this.editor?.setReadOnly(false);
        this.isOnFocus = false;
      });
    } else {
      console.log("isOnFocus", this.isOnFocus);
      setTimeout(() => {
        this.editor?.setData(this.value + "()");
        this.editor?.setReadOnly(true);
        this.editor?.setReadOnly(false);
        this.isOnFocus = false;
      });
    }
  }
}
